<form [formGroup]="form" class="api-request-trigger-form">

  <app-flow-test-customer-section
    [group]="$any(form.get('customer'))"
    [modeOptions]="customerModeOptions"
    requirementLabel="Required"
    generateHint="A sandbox customer will be generated and used as the API request target. The runner will create a sandbox foreign id internally."
    selectedHint="The selected customer will be copied into a sandbox customer for this test. The real customer is never modified."
    [userSearchTerm]="userSearchTerm"
    [userSearchResults]="userSearchResults"
    [userSearchLoading]="userSearchLoading"
    [selectedUser]="selectedUser"
    (searchInput)="onUserSearchInput($event)"
    (userPicked)="pickUser($event)"
    (userCleared)="clearUser()"
  ></app-flow-test-customer-section>

  <app-flow-test-device-section
    [group]="$any(form.get('device'))"
    [modeOptions]="deviceModeOptions"
  ></app-flow-test-device-section>

  <app-flow-test-app-state-section
    [group]="$any(form.get('accountAppDevice'))"
    [modeOptions]="appStateModeOptions"
    [locationPermissionOptions]="locationPermissionOptions"
  ></app-flow-test-app-state-section>

  <section class="section">
    <header class="section-header">
      <h4>API Payload</h4>
      <span class="hint">Optional</span>
    </header>

    <div class="field api-payload">
      <label>Request body JSON</label>
      <textarea
        [value]="apiPayloadJson"
        (input)="updateApiPayloadJson($any($event.target).value)"
        rows="8"
        [class.invalid]="!apiPayloadJsonValid"
      ></textarea>
      <p class="hint" *ngIf="apiPayloadJsonValid">
        This becomes <code>packet.data.API</code>. The production-only
        <code>account_app_user_foreign_id</code> lookup field is stripped if
        included.
      </p>
      <p class="hint error" *ngIf="!apiPayloadJsonValid">
        Payload must be a valid JSON object.
      </p>
    </div>
  </section>
</form>
